module.exports = __webpack_public_path__ + "static/media/daily absent report.52204fb4.svg";